import { useState } from "react"
import { Button } from "@f2e/ui/components/base"
import { ModeSelect } from "@f2e/ui/components/Theme"
import reactLogo from "@/assets/react.svg"
import viteLogo from "/vite.svg"

const Landing = () => {
  const [count, setCount] = useState(0)

  return (
    <main className="flex flex-col items-center justify-center h-screen">
      <div className="flex flex-col items-center gap-y-4">
        <div className="inline-flex items-center gap-x-4">
          <img src={reactLogo} alt="React Logo" className="w-32" />
          <span className="text-6xl">+</span>
          <img src={viteLogo} alt="Vite Logo" className="w-32" />
        </div>
        <Button
          variant="destructive"
          onClick={() => setCount((count) => count + 1)}
        >
          Hello Codeer!
        </Button>
        <p>Count is {count}.</p>
        <ModeSelect />
      </div>
    </main>
  )
}

export default Landing
